import { useEffect, useRef } from 'react'

/**
 * ex.
 * useIntervalPromise(async () => {
 *    const result = await application.service('credit/applications/{id}').find()
 *    setResult(result.status)
 * }, 5000)
 *
 * @param fn callback function
 * @param delay number in milliseconds for interval
 */
export const useIntervalPromise = (fn: () => Promise<void>, delay: number) => {
  const savedCallback = useRef<typeof fn>(fn)

  /**
   * Remember the latest callback
   */
  useEffect(() => {
    savedCallback.current = fn
  }, [fn])

  /**
   * Setup the interval
   */
  useEffect(() => {
    const tick = async () => savedCallback.current()

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
